
define('ldsh!common/templates/monthpicker', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<form>\n  <div class="ed-form-group from_date_group">\n    <input type="text" results="" name="from_date" data-value="' +
((__t = ( from )) == null ? '' : __t) +
'" placeholder=""\n      class="ed-form-control ed-date-item js-from-date e100">\n    <span class="ed-error-txt js-from-date-error"></span>\n  </div>\n  <div class="ed-form-group to_date_group">\n    <input type="text" results="" name="to_date" data-value="' +
((__t = ( to )) == null ? '' : __t) +
'" placeholder=""\n      class="ed-form-control ed-date-item js-to-date e100">\n    <span class="ed-error-txt js-to-date-error"></span>\n  </div>\n  ';
 if (showButton) { ;
__p += '\n    <button class="btn--primary ed-filter-btn">\n      ' +
((__t = ( buttonText )) == null ? '' : __t) +
'\n    </button>\n    ';
 } ;
__p += '\n</form>';

}
return __p
};});

